import renderInputField from 'components/FormControls/textInput'
import PropTypes from 'prop-types'
import React, { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { Field, reduxForm } from 'redux-form'
import shouldAsyncValidate from 'utils/shouldAsyncValidate'
import baseLoginValidator from 'utils/validators/baseLoginValidator'
import * as Yup from 'yup'
import LoginField from '../subcomponents/LoginField'
import { useAccountCreateFormSubmit } from 'modules/Forms/Account/Create/useAccountCreateFormSubmit'
import domainValidator from 'utils/validators/domainValidator'
import FormFrame from 'modules/Forms/Account/Create/subcomponents/FormFrame'
import clsx from 'clsx'
import formStyles from 'modules/Forms/common-form.module.scss'

export const FacebookSchema = () =>
  Yup.object().shape({
    logins: Yup.array().of(Yup.object()),
    login: Yup.string().when('logins', ([logins], schema) =>
      logins
        ? schema.strip()
        : schema
            .test('baseLoginTest', '', baseLoginValidator)
            .required('common::validation_messages.required'),
    ),
    network: Yup.string().required('common::validation_messages.required'),
    product_url: Yup.string()
      .test('domainValidator', 'common::validation_messages.incorrect_url', domainValidator)
      .required('common::validation_messages.required'),
    business_manager_id: Yup.string().required('common::validation_messages.required'),
  })

let CreateFacebookForm = ({
  handleSubmit,
  submitting,
  onClose,
  autofill,
  form,
  networkId,
  array,
  multiLogins,
  networkType,
}) => {
  const { t } = useTranslation()
  const submitAccountData = useAccountCreateFormSubmit({ form, onClose, multiLogins, networkType })

  useEffect(() => {
    if (networkId) {
      autofill('network', networkId)
    }
  }, [networkId])

  return (
    <FormFrame
      onSubmit={handleSubmit(submitAccountData)}
      multiLogins={multiLogins}
      form={form}
      submitAccountData={submitAccountData}
      submitting={submitting}
      onClose={onClose}
    >
        <Field
          disabled
          name="network"
          hidden
          fullWidth
          component={renderInputField}
          t={t}
        />

        <div className={clsx('margin-bottom-16', formStyles['row_with-tooltip'])}>
          <LoginField
            form={form}
            multiLogins={multiLogins}
            array={array}
            autofill={autofill}
            networkId={networkId}
            label={'services::forms.register_account.facebook.fields.login.label'}
          />
        </div>

        <div className={clsx('margin-bottom-16', formStyles['row_with-tooltip'])}>
          <Field
            name="product_url"
            type="text"
            fullWidth
            component={renderInputField}
            label={t('services::forms.register_account.facebook.fields.product_url.label')}
            t={t}
          />
        </div>

        <div className={clsx('margin-bottom-16', formStyles['row_with-tooltip'])}>
          <Field
            name="business_manager_id"
            type="text"
            fullWidth
            component={renderInputField}
            label={t('services::forms.register_account.facebook.fields.business_manager_id.label')}
            t={t}
            normalize={(value) => value.replace(/\D/g, '')}
          />
        </div>

    </FormFrame>
  )
}

CreateFacebookForm = reduxForm({
  form: 'CreateFacebookAccountForm',
  initialValues: {
    login: '',
    network: '',
    product_url: '',
    business_manager_id: '',
  },
  shouldAsyncValidate: shouldAsyncValidate,
})(CreateFacebookForm)

CreateFacebookForm.propTypes = {
  handleSubmit: PropTypes.func,
  submitting: PropTypes.bool,
  onClose: PropTypes.func,
  valid: PropTypes.bool,
  autofill: PropTypes.func,
  form: PropTypes.string,
  networkId: PropTypes.string,
  multiLogins: PropTypes.bool,
  array: PropTypes.object,
  networkType: PropTypes.string,
}

export default CreateFacebookForm
